import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  height: 600px;
`;

export const Display = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 600px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 1;
  /* position: relative; */
  padding: 16px;

  @media(max-width: 800px){
    padding-left: 50px;
  }
`;

export const MapContainer = styled.div`
  z-index: 0;
  overflow: hidden;
  text-overflow: ellipsis; // ou use este para adicionar "..." no final do texto cortado
  white-space: nowrap; // impede a quebra de linha
  iframe {
    overflow: hidden;
    text-overflow: ellipsis; // ou use este para adicionar "..." no final do texto cortado
    white-space: nowrap; // impede a quebra de linha
  }
`;
